import getConfig from 'next/config';
const { environment } = getConfig().publicRuntimeConfig;

export enum PostMessageType {
    hid = 'hid',
    framePageCompleted = 'framePageCompleted',
    autoLoanParams = 'autoLoanParams',
    appFramePageHeight = 'appFramePageHeight',
    event = 'event',
}

type PostMessageData =
    | {
          type: PostMessageType.hid;
          userId?: string | number;
          result?: number;
      }
    | {
          type: PostMessageType.framePageCompleted;
          result: {
              page_number: number;
          };
      }
    | {
          type: PostMessageType.autoLoanParams;
          result: {
              desired_credit_amount: FE.FieldValue;
              desired_credit_term: FE.FieldValue;
              down_payment: FE.FieldValue;
              id?: number;
          };
      }
    | {
          type: PostMessageType.appFramePageHeight;
          result: {
              height: number;
              width?: number;
              url?: string;
          };
      }
    | {
          type: PostMessageType.event;
          label: string;
      }
    | {
          application: any;
      }
    | {
          banksData: {
              bankId: string;
              bankAlias: string;
          }[];
      }
    | {
          requestId: string;
          bankData: {
              bankId: string;
              bankAlias: string;
          };
      };

/**
 * Отправляет данные в родительский фрейм.
 * @param data - любой тип, удовлетворяющий JSON.stringify
 */
export const postMessage = (data: PostMessageData) => {
    const preparedData = JSON.stringify(data);

    if (environment !== 'production') {
        console.info(`%c postmessage: ${preparedData}`, 'color: #848d95');
    }

    if (typeof window !== 'undefined' && typeof window.parent !== 'undefined') {
        window.parent.postMessage(preparedData, '*');
    }
};
